//      
import React, { Component,           } from 'react';

import { mergeClassNames } from 'utils/functions';

                       
                                          
                      
                                                              
                
                                                      
                                               
                                                     
                  
 

/** A structural component for a Container. */
export class Container extends Component                 {

    static defaultProps = {
        fluid: false,
        className: '',
        breakpoint: '',
    };

    render() {

        let { className, breakpoint, fluid, children, ...domProps } = this.props;

        let suffix = '';
        if (breakpoint) {
            suffix = breakpoint;
        } else if (fluid) {
            suffix = 'fluid';
        }

        const containerClass = suffix ? `container-${suffix}` : 'container';

        className = mergeClassNames(containerClass, this.props.className);

        return <div className={className} {...domProps}>{children}</div>;
    }
}

export default Container;
